import { apiFetch } from "@core/http";
import type { Reward, RewardInput } from "@core/types";

export type { RewardInput } from "@core/types";

const base = "/v1/portal/rewards";

export interface RewardFilter {
  active?: boolean;
  categoryId?: string;
}

export const listRewards = (filter: RewardFilter = {}) => {
  const params = new URLSearchParams();
  if (filter.active !== undefined) params.set("active", String(filter.active));
  if (filter.categoryId) params.set("categoryId", filter.categoryId);
  const suffix = params.size ? `?${params}` : "";
  return apiFetch<Reward[]>(`${base}${suffix}`);
};

// El dominio genera `code` (SPEC-210 §2, criterio 1): el formulario nunca lo
// envía, ni al crear ni al editar (contrato `RewardInput`, ajustado por
// api-http en esta misma corrida).
export const createReward = (input: RewardInput) =>
  apiFetch<Reward>(base, { method: "POST", body: input });

export const editReward = (id: string, input: RewardInput) =>
  apiFetch<Reward>(`${base}/${encodeURIComponent(id)}`, {
    method: "PUT",
    body: input,
  });

// RF-REC-03, SPEC-210 §4/§7, resolución humana PA-023-B: DELETE inactiva —
// nunca un borrado permanente. No existe un endpoint `/activate` propio para
// recompensas: reactivar es este mismo `editReward` con `active: true`.
export const inactivateReward = (id: string) =>
  apiFetch<void>(`${base}/${encodeURIComponent(id)}`, { method: "DELETE" });
